import React from "react";
import { useNavigate } from "react-router";
import { AccountContainer } from "../../../containers/user/AccountContainer";

export const AccountPage = () => {
    const navigate = useNavigate();

    return <AccountContainer onNavigateTo={navigate} />
}